import { motion } from 'framer-motion';

interface GlassButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  onClick?: () => void;
  href?: string;
  className?: string;
}

export default function GlassButton({ children, variant = 'primary', onClick, href, className = '' }: GlassButtonProps) {
  const baseClasses = 'px-8 py-3 rounded-full font-cta font-semibold text-sm smooth-transition cursor-pointer whitespace-nowrap inline-flex items-center justify-center';
  
  const variantClasses = {
    primary: 'glass-panel glow-gold-cta text-white hover-lift shimmer-cta',
    secondary: 'glass-panel glow-gold text-white hover-lift',
    outline: 'glass-panel border-2 border-gold/30 text-white hover:border-gold/60 hover-lift',
  };

  const buttonContent = (
    <motion.div
      whileHover={{ scale: 1.025 }}
      whileTap={{ scale: 0.98 }}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {buttonContent}
      </a>
    );
  }

  return buttonContent;
}
